module.exports = __webpack_public_path__ + "static/media/arquitect_4.df008c82.jpeg";